/*
  deepExtend(target, source)
 */
function deepCloneArray (arr) {
  var clone = []
  arr.forEach(function (item, index) {
    if (typeof item === 'object' && item !== null) {
      if (Array.isArray(item)) {
        clone[index] = deepCloneArray(item)
      } else {
        clone[index] = deepExtend({}, item)
      }
    } else {
      clone[index] = item
    }
  })
  return clone
}

function safeGetProperty (object, property) {
  return property === '__proto__' ? undefined : object[property]
}

var deepExtend = function (/* obj_1, [obj_2], [obj_N] */) {
  if (arguments.length < 1 || typeof arguments[0] !== 'object') {
    return false
  }

  if (arguments.length < 2) {
    return arguments[0]
  }

  var target = arguments[0]

  // convert arguments to array and cut off target object
  var args = Array.prototype.slice.call(arguments, 1)

  var val, src

  args.forEach(function (obj) {
    // skip argument if isn't an object, is null, or is an array
    if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
      return
    }

    Object.keys(obj).forEach(function (key) {
      src = safeGetProperty(target, key) // source value
      val = safeGetProperty(obj, key) // new value

      // recursion prevention
      if (val === target) {
      } else if (typeof val !== 'object' || val === null) {
        target[key] = val

        // just clone arrays (and recursive clone objects inside)
      } else if (Array.isArray(val)) {
        target[key] = deepCloneArray(val)
      } else if (typeof src !== 'object' || src === null || Array.isArray(src)) {
        target[key] = deepExtend({}, val)

        // source value and new value is objects both, extending...
      } else {
        target[key] = deepExtend(src, val)
      }
    })
  })

  return target
}

export default deepExtend



// WEBPACK FOOTER //
// ./src/tools/deepExtend.js